import Hero from '@/components/sections/fiche/hero';
import Avis from '@/components/sections/home/avis';
import Valorisation from '@/components/sections/home/valorisation';

import { Page } from '@/components/layout/page';

export default function SearchPage() {
    return (
        <Page title="Rechercher une entreprise">
            <Hero />
            <Avis />
            <Valorisation />
        </Page>
    );
}